<template>
  <div class="page">
    <div class="nav">
      <span :class="selected1 == '工单完工分析' ? 'selected1' : ''" @click="toggle1('工单完工分析')">工单完工分析</span>
      <span>|</span>
      <span :class="selected1 == '工单完工明细' ? 'selected1' : ''" @click="toggle1('工单完工明细')">工单完工明细</span>
    </div>

    <Analyies v-if="selected1 == '工单完工分析'"/>

    <Detail v-if="selected1 == '工单完工明细'"/>
  </div>
</template>

<script>
import Analyies from "@/components/MakeinReport/Analyies.vue";
import Detail from "@/components/MakeinReport/Detail.vue";

export default {
  components: {
    Analyies,
    Detail
  },
  data() {
    return {
      selected1: '工单完工分析'
    }
  },
  methods: {
    toggle1(val) {
      this.selected1 = val
    }
  }
}
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559F;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>